<template>
  <div class="meal-list" v-bind:class="{isLoading: isLoading}">
    <mu-card>
      <mu-content-block class="meal-list-header">
        <mu-flexbox align="center">
          <mu-flexbox-item style="font-size: 14px; font-weight: 600">
            {{mealTypeTitle}}
          </mu-flexbox-item>
          <mu-flexbox-item align="right">
            <slot name="button"></slot>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-content-block>
      <mu-card-text v-if="!isLoading && foods.length === 0 && recipes.length === 0">
        <span v-if="mealType === 'breakfast'" v-text="$t('message.foodDiaryNoBreakfastLabel')"></span>
        <span v-if="mealType === 'lunch'" v-text="$t('message.foodDiaryNoLunchLabel')"></span>
        <span v-if="mealType === 'dinner'" v-text="$t('message.foodDiaryNoDinnerLabel')"></span>
        <span v-if="mealType === 'snack'" v-text="$t('message.foodDiaryNoSnackLabel')"></span>
      </mu-card-text>
      <md-list v-if="isLoading">
        <mu-list-item
          v-for="item, index in dummyLoaders"
          :key="'dl-' + index"
          :title="''"
          disableRipple
        >
          <mu-linear-progress color="#0179d5"
                              style="width: 150px; height: 8px;background: #f1f1f1"></mu-linear-progress>
          <span slot="describe">
          <mu-linear-progress
            color="#0179d5"
            style="margin-bottom: 16px; height:8px; width: 80px; background: #f1f1f1"
          ></mu-linear-progress>
        </span>
        </mu-list-item>
      </md-list>
      <md-list v-if="!isLoading && (foods.length > 0 || recipes.length > 0)">
        <div v-if="(foods.length > 0 || recipes.length > 0) && !quickAddHidden" class="quickSaveNotice">
          <mu-row>
            <mu-col width="70" desktop="70" tablet="70" class="vertAlign">

              {{$t('message.foodDiarySaveMealForNextTime')}}

            </mu-col>
            <mu-col width="30" desktop="30" tablet="30" align="right">
              <mu-icon-button :tooltip="$t('message.labelYes')" icon="check" @click.native="addToMealPlate"/>
              <mu-icon-button :tooltip="$t('message.labelNo')" icon="close" @click.native="quickAddHidden = true"/>
            </mu-col>
          </mu-row>
        </div>

        <mu-list-item v-if="recipes.length > 0" v-for="item, index in recipes" :key="'recipe-' + index">


            <div slot="title">
              <img v-tooltip.top="'Low Carb Program Recipe'" style="position: relative; top: 4px;margin-right: 4px;" width="16" src="static/lcp-logo.svg">

              {{item.name}}


            </div>
          <div slot="describe">



            <div style="margin-top: 4px;" >

              <span v-text="item.servings + ' serving(s)'"></span>


            </div>
            <div class="nutrients">
              <span>{{$t('message.nutrientCarbohydrateShort')}} {{decimalize(item.carbohydrate)}}g &middot; </span>
              <span>{{$t('message.nutrientCaloriesShort')}} {{decimalize(item.calories)}}kcal &middot; </span>
              <span>{{$t('message.nutrientProtein')}} {{decimalize(item.protein)}}g &middot; </span>
              <span>{{$t('message.nutrientTotalFatShort')}} {{decimalize(item.fat)}}g &middot; </span>
              <span>{{$t('message.nutrientSaturatedFatShort')}} {{decimalize(item.saturated_fat)}}g</span>
            </div>
          </div>
          <mu-icon-menu slot="right" icon="more_vert" v-tooltip.left="'View/Edit/Delete'" :scroller="scroller">
            <mu-menu-item @click.native="viewRecipeNutrients(item)"
                          :title="$t('message.labelViewNutrition')"></mu-menu-item>
            <mu-menu-item @click.native="goToRecipe(item)" title="Go to recipe"></mu-menu-item>
            <mu-menu-item @click.native="openEditRecipeEntryDialog(item)" :title="$t('message.editText')"/>
            <mu-menu-item @click.native="deleteRecipe(item, index)" :title="$t('message.deleteText')"/>
          </mu-icon-menu>
        </mu-list-item>

        <mu-list-item
          v-if="foods.length > 0 "
          v-for="(food, index) in foods"
          :key="'food-' + index"
          :title="food.food_name"
          disableRipple
        >
          <div slot="describe">
            <div class="brandName" v-if="food.brand_name !==''" v-text="food.brand_name"></div>
            <div v-text="food.servings + ' x '  +  food.serving_description"></div>
            <div class="nutrients">
              <span>{{$t('message.nutrientCarbohydrateShort')}} {{decimalize(food.nutrients.carbohydrate * food.servings)}}g &middot; </span>
              <span>{{$t('message.nutrientCaloriesShort')}} {{decimalize(food.nutrients.calories * food.servings)}}kcal &middot; </span>
              <span>{{$t('message.nutrientProtein')}} {{decimalize(food.nutrients.protein * food.servings)}}g &middot; </span>
              <span>{{$t('message.nutrientTotalFatShort')}} {{decimalize(food.nutrients.fat * food.servings)}}g &middot; </span>
              <span>{{$t('message.nutrientSaturatedFatShort')}} {{decimalize(food.nutrients.saturated_fat * food.servings)}}g</span>
            </div>
          </div>
          <mu-icon-menu slot="right" icon="more_vert" v-tooltip.left="'View/Edit/Delete'" :scroller="scroller">
            <mu-menu-item @click.native="viewNutrients(food)" :title="$t('message.labelViewNutrition')"></mu-menu-item>
            <mu-menu-item @click.native="editFood(food)" :title="$t('message.editText')"/>
            <mu-menu-item @click.native="deleteFood(food, index)" :title="$t('message.deleteText')"/>
          </mu-icon-menu>
        </mu-list-item>
      </md-list>
      <mu-flexbox class="nutritionalValues" v-if="!isLoading">
        <mu-flexbox-item class="center">
          <div class="nutritional-header">{{$t('message.nutrientCarbohydrateShort')}}</div>
          <div>
            {{decimalize(totals.carbohydrate)}}g
          </div>
        </mu-flexbox-item>
        <mu-flexbox-item class="center">
          <div class="nutritional-header">{{$t('message.nutrientCaloriesShort')}}</div>
          <div>
            {{decimalize(totals.calories)}}kcal
          </div>
        </mu-flexbox-item>
        <mu-flexbox-item class="center">
          <div class="nutritional-header">{{$t('message.nutrientProtein')}}</div>
          <div>
            {{decimalize(totals.protein)}}g
          </div>
        </mu-flexbox-item>
        <mu-flexbox-item class="center">
          <div class="nutritional-header"> {{$t('message.nutrientTotalFatShort')}}</div>
          <div>
            {{decimalize(totals.fat)}}g
          </div>
        </mu-flexbox-item>
        <mu-flexbox-item class="center last">
          <div class="nutritional-header">{{$t('message.nutrientSaturatedFatShort')}}</div>
          <div>
            {{decimalize(totals.saturated_fat)}}g
          </div>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card>


    <md-dialog ref="recipeNutritionDialog" class="nutrition-dialog">
      <mu-card-header
        :title="activeRecipeObject.name"
        :subTitle="activeRecipeObject.servings + ' serving(s)'"
        titleClass="blueTitle largeTitle"
      ></mu-card-header>
      <div style="overflow-x: hidden;overflow-y: scroll;-webkit-overflow-scrolling: touch;">
        <mu-list class="oddEven">
          <mu-list-item
            disableRipple
            v-for="(value, key) in activeRecipeObject.nutrients"
            :key="'nutrients-'+ key"
            :title="$t(localizeNutrient(key))"
            :afterText="'' + decimalize(value) + getUnit(key)"
          >
          </mu-list-item>
        </mu-list>
      </div>
    </md-dialog>


    <md-dialog ref="editRecipeDialog" class="edit-recipe-dialog">
      <mu-card-header
        :title="editRecipeEntryModel.name"
        subTitle=" This food is added from the recipe area and is limited to modifying serving sizes only"
      ></mu-card-header>
      <div>

        <form @submit.prevent="updateRecipeEntry">
          <mu-card-text>
            <mu-text-field
              fullWidth
              label="Servings"
              type="number"
              v-model="editRecipeEntryModel.servings"
            ></mu-text-field>

            <mu-raised-button :disabled="isRecipeUpdating" type="button" @click.native="updateRecipeEntry" full-width :label="$t('message.updateText')"></mu-raised-button>


            <mu-raised-button :disabled="isRecipeUpdating" style="display: none;" type="submit" full-width :label="$t('message.updateText')"></mu-raised-button>
          </mu-card-text>
        </form>
      </div>
    </md-dialog>


    <md-dialog ref="nutritionDialog" class="nutrition-dialog">
      <mu-card-header
        :title="activeFoodObject.food_name"
        :subTitle="activeFoodObject.servings + ' x ' + activeFoodObject.serving_description"
        titleClass="blueTitle largeTitle"
      ></mu-card-header>
      <div style="overflow-x: hidden;overflow-y: scroll;-webkit-overflow-scrolling: touch;">
        <mu-list class="oddEven">
          <mu-list-item
            disableRipple
            v-for="(value, key) in activeFoodObject.nutrients"
            :key="'nutrient-'+ key"
            :title="$t(localizeNutrient(key))"
            :afterText="'' + decimalize(value * activeFoodObject.servings) + getUnit(key)"
          >
          </mu-list-item>
        </mu-list>
      </div>
    </md-dialog>

    <md-dialog ref="mealPlateNamer" class="nutrition-dialog">
      <mu-card-header
        :title="$t('message.foodDiaryMealPlateNameTitle')"
        titleClass="blueTitle largeTitle"
      ></mu-card-header>
      <form @submit.prevent="saveMealPlate">
        <mu-card-text>
          <div style="overflow-x: hidden;overflow-y: scroll;-webkit-overflow-scrolling: touch;">
            <mu-text-field
              data-vv-validate-on="none"
              :data-vv-rules="'required'"
              data-vv-name="nameText"
              :data-vv-as="$t('message.nameText')"
              data-vv-value-path="inputValue"
              :label="$t('message.nameText')"
              :hint-text="$t('message.placeholderText')"
              v-model="mealPlateName"
              full-width
            ></mu-text-field>
          </div>
        </mu-card-text>
        <mu-card-actions align="right">
          <mu-raised-button
            type="button"
            @click.native="saveMealPlate"
            secondarys
            :disabled="isRecipeUpdating"
            :label="$t('message.saveText')">
          </mu-raised-button>
          <button type="submit" style="display: none;"></button>
        </mu-card-actions>
      </form>
    </md-dialog>
  </div>
</template>
<script>

  import FoodApi from '../../../api/Food'
  import FoodDiaryNutritionMixin from '../../../mixins/FoodDiaryNutritionMixin'
  import NutrientLocalizerMixin from '../../../mixins/Localization/FoodNutrients/NutrientLocalizer'
  import ScrollerMixin from '../../../mixins/ScrollerMixin'
  import numeral from 'numeral'
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
  import MuIconButton from "muse-ui/src/iconButton/iconButton";
  import MuTextField from "muse-ui/src/textField/textField";
  import MuCardActions from "muse-ui/src/card/cardActions";


  export default {
    components: {
      MuCardActions,
      MuTextField,
      MuIconButton,
      MuRaisedButton
    },
    mixins: [ScrollerMixin, FoodDiaryNutritionMixin, NutrientLocalizerMixin],
    name: 'food-diary-meal-list',
    props: {
      isLoading: {
        type: Boolean,
        default: true
      },
      mealTypeTitle: {
        type: String,
        default: "Breakfast"
      },
      mealType: {
        type: String,
        default: 'breakfast'
      },
      foods: {
        type: Array,
        default: []
      },
      recipes: {
        type: Array,
        default: []
      },
      totals: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isRecipeUpdating: false,
        deleteId: null,
        quickAddHidden: false,
        activeFoodObject: {},
        activeRecipeObject: {},
        mealPlateName: null,
        isMealPlateSaving: false,
        editRecipeEntryModel: {
          servings: 0,
          id: 0,
          name: null
        },
        dummyLoaders: [
          {}
        ]
      }
    },
    watch: {
      'foods': function () {
        let self = this;
      }
    },
    methods: {
      viewRecipeNutrients(recipe) {
        let self = this;
        let copy = recipe;
        let activeRecipeObject = {
          name: recipe.name,
          servings: recipe.servings,
          nutrients: {
            carbohydrate: recipe.carbohydrate,
            calories: recipe.calories,
            sodium: recipe.sodium,
            sugar: recipe.sugar,
            monounsaturated_fat: recipe.monounsaturated_fat,
            polyunsaturated_fat: recipe.polyunsaturated_fat,
            saturated_fat: recipe.saturated_fat,
            fat: recipe.fat,
            fibre: recipe.fibre,
            protein: recipe.protein,
            potassium: recipe.potassium
          }
        };

        self.activeRecipeObject = activeRecipeObject;
        self.$refs.recipeNutritionDialog.open();
      },
      openEditRecipeEntryDialog(recipe) {
        let self = this;
        self.editRecipeEntryModel.name = recipe.name;
        self.editRecipeEntryModel.id = recipe.id;
        self.editRecipeEntryModel.servings = recipe.servings;
        self.$refs.editRecipeDialog.open();
      },
      updateRecipeEntry(recipe) {
          let self = this;
          self.isRecipeUpdating = true;
          FoodApi.updateRecipe(self.editRecipeEntryModel)
            .then(function (response) {
              self.$refs.editRecipeDialog.close();
              self.isRecipeUpdating = false;
              self.$emit('reloadData');
            })
            .catch(function (error) {
              self.isRecipeUpdating = false;
            })
      },
      deleteRecipe(recipe, index) {

        let self = this;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveFoodItem') + recipe.name,
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return FoodApi.deleteRecipe(recipe.id)
          }
        })
          .then(function () {
            self.$emit('removeRecipe', {
              type: self.mealType,
              index: index
            });
            self.$forceUpdate();
            self.$emit('updateTotals', recipe);
          })
          .catch(self.$alert.noop)
      },
      saveMealPlate() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true && self.mealPlateName !== null && self.mealPlateName !== "") {
              let foods = [];
              let recipes = self.recipes;
              for (let i = 0; i < self.foods.length; i++) {
                let food = {
                  food_id: self.foods[i].fs_food_id,
                  food_name: self.foods[i].food_name,
                  nutrients: self.foods[i].nutrients,
                  serving_id: self.foods[i].fs_serving_id,
                  servings: self.foods[i].servings
                };
                foods.push(food);
              }

              let model = {
                meal_name: self.mealPlateName,
                foods: foods,
                recipes: recipes
              };

              self.isMealPlateSaving = true;
              FoodApi.addToFavourites(model)
                .then(function (response) {
                  self.isMealPlateSaving = false;
                  self.$refs['mealPlateNamer'].close();
                  self.$toastr.success(self.$t('message.labelSuccess'))
                })
                .catch(function (error) {
                  self.isMealPlateSaving = false;
                  self.$refs['mealPlateNamer'].close();
                  self.$toastr.success(self.$t('message.labelError'))
                });
            }
          })
      },
      editFood(food, index) {
        let self = this;
        if (self.mealType === "breakfast") {
          food.mealTypeId = 1;
        }
        else if (self.mealType === "lunch") {
          food.mealTypeId = 2;
        }
        else if (self.mealType === "dinner") {
          food.mealTypeId = 3;
        }
        else if (self.mealType === "snack") {
          food.mealTypeId = 4;
        }
        self.$emit('foodSelected', food);
      },
      viewNutrients(food) {
        let self = this;
        self.activeFoodObject = food;
        self.$refs['nutritionDialog'].open();
      },
      emitParent() {
        let self = this;
        self.$emit('removeFood', self.deleteId);
      },
      addToMealPlate() {
        let self = this;
        self.$refs['mealPlateNamer'].open();
        //Hides quick save after submitting.
        self.quickAddHidden = true;
      },
      goToRecipe(item) {
        let self = this;
        self.$router.push( {
          name: 'RecipeDetail',
          params: {
            id: item.recipeID
          }
        })

      },
      deleteFood(food, index) {
        let self = this;
        let swal = self.$alert;
        self.deleteId = index;


        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveFoodItem') + food.food_name,
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return FoodApi.deleteFood(food.food_id)
          }
        })
          .then(function () {

            let substitutableNutrients = food.nutrients;
            for (let key in substitutableNutrients) {
              if (substitutableNutrients.hasOwnProperty(key)) {
                substitutableNutrients[key] = substitutableNutrients[key] * food.servings;
              }
            }
            Number.prototype.clamp = function (min, max) {
              return Math.min(Math.max(this, min), max);
            };
            self.totals.calories = (self.totals.calories - substitutableNutrients.calories).clamp(0, Infinity);
            self.totals.carbohydrate = (self.totals.carbohydrate - substitutableNutrients.carbohydrate).clamp(0, Infinity);
            self.totals.cholesterol = (self.totals.cholesterol - substitutableNutrients.cholesterol).clamp(0, Infinity);
            self.totals.fat = (self.totals.fat - substitutableNutrients.fat).clamp(0, Infinity);
            self.totals.fibre = (self.totals.fibre - substitutableNutrients.fibre).clamp(0, Infinity);
            self.totals.monounsaturated_fat = (self.totals.monounsaturated_fat - substitutableNutrients.monounsaturated_fat).clamp(0, Infinity);
            self.totals.polyunsaturated_fat = (self.totals.polyunsaturated_fat - substitutableNutrients.polyunsaturated_fat).clamp(0, Infinity);
            self.totals.potassium = (self.totals.potassium - substitutableNutrients.potassium).clamp(0, Infinity);
            self.totals.protein = (self.totals.protein - substitutableNutrients.protein).clamp(0, Infinity);
            self.totals.saturated_fat = (self.totals.saturated_fat - substitutableNutrients.saturated_fat).clamp(0, Infinity);
            self.totals.sodium = (self.totals.sodium - substitutableNutrients.sodium).clamp(0, Infinity);
            self.totals.sugar = (self.totals.sugar - substitutableNutrients.sugar).clamp(0, Infinity);
            self.emitParent();
            self.$emit('updateTotals', substitutableNutrients);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: food.food_name + ' ' + self.$t('message.confirmedRemoveFoodItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            });
            if (self.foods.length === 0) {
              self.totals.calories = 0;
              self.totals.carbohydrate = 0;
              self.totals.cholesterol = 0;
              self.totals.fat = 0;
              self.totals.fibre = 0;
              self.totals.monounsaturated_fat = 0;
              self.totals.polyunsaturated_fat = 0;
              self.totals.potassium = 0;
              self.totals.protein = 0;
              self.totals.saturated_fat = 0;
              self.totals.sodium = 0;
              self.totals.sugar = 0;
            }
          }.bind(self))
          .catch(self.$alert.noop)
      },
    }
  }
</script>
<style lang="less">


  .md-dialog-container.edit-recipe-dialog.md-theme-default.md-active .mu-card-header-title {
    padding-right:  0;
  }

  .meal-list {
    .isLoading {
      opacity: 0.8;
    }

    .quickSaveNotice {
      margin-top: -8px;
      color: white;
      background: #3d8517;
      .vertAlign {
        padding-left: 16px;
        color: white;
        vertical-align: middle;
        height: 100%;
        display: flex;
        align-self: center;

        @media (max-width: 480px) {
          font-size: 12px;
        }

      }
    }

    .center {
      text-align: center;
    }

    .mu-item .mu-item-text {
      height: auto !important;
      max-height: initial !important;
    }
    .brandName {
      margin-bottom: 8px;
    }
    .mu-card-header-title {
      padding-right: 0;
    }

    .meal-list-header {
      background: #0179d5;
      color: white !important;
      padding: 4px 16px !important;
    }

    .meal-list-header * {
      color: white !important;
    }

    .mu-flexbox.nutritionalValues.mu-flex-row {
      border-top: 1px solid #edeaf5;
      font-size: 16px;
    }

    .mu-flexbox.nutritionalValues > div {
      padding: 8px;
    }
  }

  .nutritionalValues .mu-flexbox-item.center {
    padding: 4px;
    border-right: 1px solid #edeaf5;
  }

  .nutritionalValues .mu-flex-row .mu-flex-item:last-child {
    border-right: 0px;
  }

  .nutritionalValues .last {
    border-right: 0px !important;
    border-right: 0px !important;
  }

  @media (max-width: 600px) {
    .mu-flexbox.nutritionalValues.mu-flex-row {
      font-size: 12px !important;
    }

    .nutritional-header {
      font-size: 14px !important;
      color: #0179d5;
    }
  }

  .nutritional-header {
    font-size: 16px;
    color: #0179d5;
  }

  .nutrition-dialog .md-dialog {
    width: 300px;
    @media (min-width: 600px) {
      width: 600px;
    }
  }

  .meal-list .mu-item-text {
    max-height: 100% !important;
    height: 100% !important;
    -webkit-line-clamp: initial !important;
  }

  .nutrients {
    margin-top: 4px;
    color: #6c6c6c;
    @media (max-width: 600px) {
      font-size: 9px;
    }
  }
</style>



// WEBPACK FOOTER //
// MealList.vue?7a54c7d7